module.exports = __webpack_public_path__ + "img/torch.1bcb8a02.gif";